<mat-toolbar>

    <button matIconButton (click)="menuClick()" aria-label="Menu toggle"
        matTooltip="{{ 'menu.menuToggle' | translate }}">
        <mat-icon>menu</mat-icon>
    </button>
    
    <div class="title" routerLink="/">{{'app.title' |  translate}} | {{title()}}</div>

    <div class="remaining-space"></div>

    <app-sap-token-button />

    <app-help-button (click)="clickEvent.emit('help')" />

    <app-full-screen-button />
    
    <app-notifications-button (click)="clickEvent.emit('notifications')" />
    
    <app-preferences-button (click)="clickEvent.emit('preferences')" />

    <app-avatar-button />

</mat-toolbar>